export default __webpack_public_path__ + "static/media/IconDesc_Cables.64.b3b85134.png";